import { Trans, useTranslation } from 'next-i18next';
import React from 'react';

import Logo from '../Header/Logo';
import StyledTitleTypography from './StyledTitleTypography';
import StyledTypography from './StyledTypography';
import StyledWrapper from './StyledWrapper';
import TextDiv from './TextDiv';

const OnboardingHero: React.FC = () => {
  const { t } = useTranslation(['site']);

  return (
    <StyledWrapper>
      <Logo />

      <TextDiv>
        <StyledTitleTypography
          variant='jumbo'
          color='white'
          weight='semibold'
        >
          <Trans
            t={t}
            i18nKey='site:onboardingTitle'
          />
        </StyledTitleTypography>
        <StyledTypography
          variant='body2'
          weight='light'
          color='lightPeriwinkle'
        >
          <Trans
            t={t}
            i18nKey='site:onboardingSubtitle'
          />
        </StyledTypography>
      </TextDiv>
    </StyledWrapper>
  );
};

export default OnboardingHero;
